(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(10576);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_text_truncate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37856);
/* harmony import */ var react_text_truncate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_text_truncate__WEBPACK_IMPORTED_MODULE_1__);


// expmple of usage:
// const StyledTruncateText = styled(TruncateText)`
//   text-align: right;
//   font-size: 14px;
//   color: ${(p) => p.theme.colors.marbleGrey};
// `
// <StyledTruncateText
// line={2}
// element="span"
// truncateText="…"
// text={productData.short_description}
// />
var TruncateText = function(param) {
    var line = param.line, element = param.element, truncateText = param.truncateText, text = param.text, textTruncateChild = param.textTruncateChild, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_truncate__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: className,
        line: line,
        element: element,
        truncateText: truncateText,
        text: text,
        textTruncateChild: textTruncateChild,
        style: {
            display: "flex"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TruncateText);


/***/ }),

/***/ 13354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ isValidMediaUrl; }
/* harmony export */ });
var isValidMediaUrl = function(url) {
    try {
        var parsedUrl = new URL(url);
        return (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") && parsedUrl.pathname !== "/";
    } catch (error) {
        return false;
    }
};


/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  border-radius: 400px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  border: 2px solid #ffffff;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  width: ",
        ";\n  height: ",
        ";\n  padding: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var circleStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), function(p) {
    return "".concat(p.$height, "px");
}, function(p) {
    return "".concat(p.$height, "px");
});
var StyledCircleButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "ColorCircle__StyledCircleButton",
    componentId: "sc-7653b1a1-0"
})(_templateObject1(), circleStyle);
var StyledCircleDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircle__StyledCircleDiv",
    componentId: "sc-7653b1a1-1"
})(_templateObject2(), circleStyle);
var ImageWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircle__ImageWrap",
    componentId: "sc-7653b1a1-2"
})(_templateObject3());
var ColorCircle = function(param) {
    var _height = param.height, height = _height === void 0 ? 85 : _height, className = param.className, imageUrl = param.imageUrl, additionalPrice = param.additionalPrice, disableButton = param.disableButton, onClick = param.onClick;
    // set StyledCircle to be a button or a div react component
    var StyledCircle = disableButton ? StyledCircleDiv : StyledCircleButton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCircle, {
        className: className,
        $height: height,
        onClick: onClick,
        children: imageUrl && imageUrl !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrap, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: imageUrl,
                alt: additionalPrice ? "בתוספת מחיר" : "color Backround",
                width: height,
                height: height,
                objectFit: "cover"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorCircle);


/***/ }),

/***/ 86437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keyFrameCircle */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { opacity: 1; scale:1; }\n  60% { opacity: 0.6; }\n  80% { opacity: 0.3; scale:120; }\n  100% { opacity: 0; scale:120; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  margin: 0px auto;\n  border-radius: 100%;\n  background-color: ",
        ";\n  z-index: 10;\n  opacity: 0;\n  animation: ",
        ";\n  /* mix-blend-mode: multiply; */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var keyFrameCircle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var StyledWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircleAnimation__StyledWrap",
    componentId: "sc-833f03dd-0"
})(_templateObject1());
var StyledColorAnimation = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircleAnimation__StyledColorAnimation",
    componentId: "sc-833f03dd-1"
})(_templateObject3(), function(p) {
    return p.$color;
}, function(param) {
    var $colorChange = param.$colorChange, $animationTime = param.$animationTime;
    return $colorChange && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), keyFrameCircle, $animationTime ? "2000ms linear forwards" : "1200ms linear forwards");
});
var ColorCircleAnimation = function(param) {
    var animationFlag = param.animationFlag, hex = param.hex, className = param.className, animationTime = param.animationTime;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: animationFlag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrap, {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledColorAnimation, {
                $colorChange: animationFlag,
                $color: hex,
                $animationTime: animationTime
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorCircleAnimation);


/***/ }),

/***/ 72820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].darkGrey */ .Z.darkGrey : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "50",
            height: "50",
            viewBox: "0 0 50 50",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "48",
                    height: "48",
                    rx: "24",
                    stroke: color,
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.5 22.75L25 27.25L29.5 22.75",
                    stroke: color,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    id: "arrow"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 10576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/icons/MoreInfoWhite.tsx
var MoreInfoWhite = __webpack_require__(72820);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./common/bit/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(49138);
// EXTERNAL MODULE: ./common/bit/TruncateText.tsx
var TruncateText = __webpack_require__(48868);
;// CONCATENATED MODULE: ./common/getFormattedDate.ts

var options = {
    separator: "/",
    format: "dd/mm/yyyy"
};
var getFormattedDate = function(date) {
    var obj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : options;
    var _separator = obj.separator, separator = _separator === void 0 ? "/" : _separator, _format = obj.format, format = _format === void 0 ? "dd/mm/yyyy" : _format;
    var created = new Date(date);
    var dd = String(created.getDate()).padStart(2, "00");
    var mm = String(created.getMonth() + 1).padStart(2, "00");
    var yyyy = created.getFullYear();
    var formats = {
        "dd/mm/yyyy": [
            dd,
            mm,
            yyyy
        ],
        "yyyy/mm/dd": [
            yyyy,
            mm,
            dd
        ],
        "mm/yyyy": [
            mm,
            yyyy
        ]
    };
    return formats[format].join(separator);
};
var checkDateFormat = function(date) {
    // check if a sting in format DD/MM/YYYY
    var regex = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
    return regex.test(date);
};
var transformToISOdate = function(dateString) {
    // DD/MM/YYYY
    // // expected output: 2011-10-05T14:48:00.000Z
    var newDate = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
    var event = new Date(newDate);
    return event.toISOString();
};
var fromDDMMStringToData = function(str) {
    if (checkDateFormat(str)) {
        var ref = _sliced_to_array(str.split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
        var date = new Date(+year, parseInt(month) - 1, +day);
        return date // 👉️ Fri Apr 22 2022
        ;
    }
    return null;
};
var fromISOToDateString = function(str) {
    var date = new Date(str);
    return date.toLocaleDateString("en-us", {
        // weekday: 'long',
        year: "numeric",
        month: "short",
        day: "numeric"
    }) // // 👉️ Aug 11, 2022
    ;
} // https://www.freecodecamp.org/news/how-to-format-dates-in-javascript/
 // toString() => Fri Jul 02 2021 14:03:54 GMT+0100 (British Summer Time)
 // toDateString() => Fri Jul 02 2021
 // toLocaleString() => 2/7/2021, 2:03:54 PM
 // toLocaleDateString() => 2/7/2021
 // toLocaleTimeString() => 2:03:54 PM
 // toISOString() => 2021-07-02T13:03:54.000Z
;

;// CONCATENATED MODULE: ./components/homepage/blog/BlogCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: 1s;\n  :hover,\n  :focus {\n    transform: scale(1.2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: ",
        ";\n  height: 100%;\n  width: 100%;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n  max-width: 480px;\n  ",
        " {\n    height: auto;\n    align-self: stretch;\n    ",
        " {\n      height: auto;\n      &:nth-child(4) {\n        transform: ",
        ";\n        opacity: ",
        ";\n      }\n      &:nth-child(3) {\n        transform: ",
        ";\n        opacity: ",
        ";\n      }\n      &:nth-child(2) {\n        transform: ",
        ";\n        opacity: ",
        ";\n      }\n      &:nth-child(1) {\n        transform: ",
        ";\n        opacity: ",
        ";\n      }\n\n      transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n      transition-delay: 0.3s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: 320/261;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 18px 18px;\n  flex-grow: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0px;\n  margin-bottom: 10px;\n  overflow: hidden;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 18px;\n  color: ",
        ";\n  line-height: 150%;\n  text-align: center !important;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: auto;\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(NextImage/* default */.Z).withConfig({
    displayName: "BlogCard__StyledImage",
    componentId: "sc-dba21ca-0"
})(_templateObject());
var StyledPaper = (0,styled_components_browser_esm/* default */.ZP)(Paper/* default */.Z).withConfig({
    displayName: "BlogCard__StyledPaper",
    componentId: "sc-dba21ca-1"
})(_templateObject1(), function(p) {
    return p.theme.boxShadows.cardShadow;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-10%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-110%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-210%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-310%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BlogCard__StyledImageContainer",
    componentId: "sc-dba21ca-2"
})(_templateObject2());
var StyledTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledCol */.N6).withConfig({
    displayName: "BlogCard__StyledTextWrapper",
    componentId: "sc-dba21ca-3"
})(_templateObject3());
var StyledDateText = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BlogCard__StyledDateText",
    componentId: "sc-dba21ca-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.onyx;
});
var StyledTruncateTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BlogCard__StyledTruncateTextWrapper",
    componentId: "sc-dba21ca-5"
})(_templateObject5());
var StyledTruncateText = (0,styled_components_browser_esm/* default */.ZP)(TruncateText/* default */.Z).withConfig({
    displayName: "BlogCard__StyledTruncateText",
    componentId: "sc-dba21ca-6"
})(_templateObject6(), function(p) {
    return p.theme.colors.black;
});
var StyledIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BlogCard__StyledIconWrapper",
    componentId: "sc-dba21ca-7"
})(_templateObject7());
var StyledBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BlogCard__StyledBox",
    componentId: "sc-dba21ca-8"
})(_templateObject8());
var BlogCard = function(param) {
    var blogDate = param.blogDate, inView = param.inView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
        href: blogDate === null || blogDate === void 0 ? void 0 : blogDate.link,
        openInNewTab: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPaper, {
            $inView: inView,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        image: blogDate === null || blogDate === void 0 ? void 0 : blogDate.image
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapper, {
                    $fullWidth: true,
                    $gap: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                            variant: "h3",
                            children: blogDate === null || blogDate === void 0 ? void 0 : blogDate.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateText, {
                            children: fromISOToDateString(blogDate === null || blogDate === void 0 ? void 0 : blogDate.date)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTruncateTextWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTruncateText, {
                                line: 2,
                                element: "span",
                                truncateText: "…",
                                text: blogDate === null || blogDate === void 0 ? void 0 : blogDate.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconWrapper, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    children: "לקריאה"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                        src: "/icons/exit-site.svg",
                                        alt: "מעבר לאתר חיצוני",
                                        w: 24,
                                        h: 24
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var blog_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/homepage/blog/Blog.tsx

function Blog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 80px 20px;\n  ",
        " {\n    padding: 62px 60px;\n    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n    transform: ",
        ";\n    opacity: ",
        ";\n    transition-delay: 0.3s;\n  }\n"
    ]);
    Blog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Blog_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n"
    ]);
    Blog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Blog_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 80px;\n  margin: 80px 0px;\n  ",
        " {\n    flex-direction: row;\n    margin: 60px 0px;\n\n    justify-content: stretch;\n  }\n"
    ]);
    Blog_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var StyledWrapperContainer = (0,styled_components_browser_esm/* default */.ZP)(shared/* HomePageContainer */.Ts).withConfig({
    displayName: "Blog__StyledWrapperContainer",
    componentId: "sc-280ea54c-0"
})(Blog_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "translate3d(0, 0, 0)" : "translate3d(0, -85px, 0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h1",
    component: "h2"
}).withConfig({
    displayName: "Blog__StyledTitle",
    componentId: "sc-280ea54c-1"
})(Blog_templateObject1());
var StyledCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Blog__StyledCardWrapper",
    componentId: "sc-280ea54c-2"
})(Blog_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var Blog = function(param) {
    var blogData = param.blogData;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        children: !!(blogData === null || blogData === void 0 ? void 0 : blogData.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperContainer, {
            $inView: inView,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                    children: "ZoOM BLOG"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardWrapper, {
                    children: blogData === null || blogData === void 0 ? void 0 : blogData.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogCard, {
                            inView: inView,
                            blogDate: item
                        }, item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "https://blog.mazda.co.il/",
                    openInNewTab: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        children: "לכלל הכתבות"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blog_Blog = (Blog);

// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
// EXTERNAL MODULE: ./reusable/ButtonBaseBlank.tsx
var ButtonBaseBlank = __webpack_require__(59041);
// EXTERNAL MODULE: ./reusable/colors/ColorCircle.tsx
var ColorCircle = __webpack_require__(10682);
// EXTERNAL MODULE: ./reusable/colors/ColorCircleAnimation.tsx
var ColorCircleAnimation = __webpack_require__(86437);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/ColorImageSwiper.tsx
var ColorImageSwiper = __webpack_require__(46973);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/SwiperFooterText.tsx
var SwiperFooterText = __webpack_require__(65138);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/SwiperTopText.tsx
var SwiperTopText = __webpack_require__(96164);
;// CONCATENATED MODULE: ./components/homepage/colorSwiper/SwiperMain.tsx

function SwiperMain_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  contain: paint;\n  position: relative;\n  z-index: 0;\n  height: 660px;\n  /* height: calc(100vh - ",
        "px); */\n  background-color: ",
        ";\n  ",
        " {\n    min-height: calc(100vh - ",
        "px);\n    height: fit-content;\n  }\n  /* opacity: 0; */\n"
    ]);
    SwiperMain_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  contain: paint;\n  max-width: 100vw;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  ",
        " {\n    justify-content: center;\n    min-height: calc(100vh - ",
        "px);\n    height: 100%;\n  }\n"
    ]);
    SwiperMain_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n  0% { clip-path: circle(\n    25px at calc(100% - 100px)\n      calc(100% + 100px)\n  );\n}\n\n  80% { clip-path: circle(\n    250% at calc(100% - 100px)\n      calc(100% + 100px)\n  );\n}\n  100% { clip-path: circle(\n    110% at calc(100% - 100px)\n      calc(120% + 100px)\n  );\n  }\n"
    ]);
    SwiperMain_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n  0% { clip-path: circle(\n    50px at calc(100% - 30px) calc(100% - 110px)\n  ); }\n\n  80% { clip-path: circle(\n    350%  at calc(100% - 30px) calc(100% - 110px)\n  ); }\n  100% { clip-path: circle(\n    110%  at calc(100% - 30px) calc(100% - 110px)\n  ); }\n"
    ]);
    SwiperMain_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " 1200ms  linear forwards\n    "
    ]);
    SwiperMain_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        " 1200ms  linear forwards\n      "
    ]);
    SwiperMain_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  clip-path: circle(50px at calc(100% - 30px) calc(100% - 110px));\n  visibility: ",
        ";\n  animation: ",
        ";\n  ",
        " {\n    clip-path: circle(25px at calc(100% - 100px) calc(100% + 100px));\n    animation: ",
        ";\n  }\n  background-color: ",
        ";\n"
    ]);
    SwiperMain_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 20px;\n  right: 0px;\n  left: auto;\n  position: absolute;\n"
    ]);
    SwiperMain_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SwiperMain_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 60px;\n  right: -20px;\n  ",
        " {\n    bottom: 40px;\n    right: 50px;\n  }\n"
    ]);
    SwiperMain_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% {left: -200px}\n    20% {left: 100%}\n    100% {left: 100%}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  border: 4px solid #ffffff;\n  /* cardShaddow */\n\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  /* before */\n  :before {\n    /* content: "";\n    position: absolute;\n    width: 250px;\n    height: 100%;\n    background-image: linear-gradient(\n      28deg,\n      rgba(255, 255, 255, 0) 45%,\n      rgba(255, 255, 255, 0.5),\n      rgba(255, 255, 255, 0) 55%\n    );\n    top: 0;\n    left: -200px;\n    animation: ',
        " 4s infinite linear; /* Animation\n    z-index: 1000;\n    mix-blend-mode: soft-light;*/\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        " {\n    color: ",
        ";\n    inset: 0;\n    inset-inline-start: 9px;\n    padding: 6px;\n    left: auto;\n    position: absolute;\n    text-shadow: 0px 4px 10px rgb(0 0 0 / 10%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n  ",
        " {\n    color: ",
        ";\n    margin-top: 4px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}














var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwiperMain__StyledWrap",
    componentId: "sc-65cfb678-0"
})(SwiperMain_templateObject(), shared/* HEADER_HEIGHT_M */.Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_HEIGHT_D */.gw);
var StyledSwiperMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwiperMain__StyledSwiperMain",
    componentId: "sc-65cfb678-1"
})(SwiperMain_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_HEIGHT_D */.gw);
var keyFrameCircleDesktop = (0,styled_components_browser_esm/* keyframes */.F4)(SwiperMain_templateObject2());
var keyFrameCircleMobile = (0,styled_components_browser_esm/* keyframes */.F4)(SwiperMain_templateObject3());
var StyledDuplicateSwiperMain = (0,styled_components_browser_esm/* default */.ZP)(StyledSwiperMain).withConfig({
    displayName: "SwiperMain__StyledDuplicateSwiperMain",
    componentId: "sc-65cfb678-2"
})(SwiperMain_templateObject6(), function(param) {
    var $start = param.$start;
    return $start ? "visible" : "hidden";
}, function(param) {
    var $start = param.$start;
    return $start && (0,styled_components_browser_esm/* css */.iv)(SwiperMain_templateObject4(), keyFrameCircleMobile);
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $start = param.$start;
    return $start && (0,styled_components_browser_esm/* css */.iv)(SwiperMain_templateObject5(), keyFrameCircleDesktop);
}, function(p) {
    return p.theme.colors.lightGrey;
});
var StyledColorCircleAnimation = (0,styled_components_browser_esm/* default */.ZP)(ColorCircleAnimation/* default */.Z).withConfig({
    displayName: "SwiperMain__StyledColorCircleAnimation",
    componentId: "sc-65cfb678-3"
})(SwiperMain_templateObject7());
var StyledAnimationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwiperMain__StyledAnimationWrapper",
    componentId: "sc-65cfb678-4"
})(SwiperMain_templateObject8(), function(p) {
    return p.theme.breakpoints.up("md");
});
var shine = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject9());
var StyledColorCircle = (0,styled_components_browser_esm/* default */.ZP)(ColorCircle/* default */.Z).withConfig({
    displayName: "SwiperMain__StyledColorCircle",
    componentId: "sc-65cfb678-5"
})(_templateObject10(), shine);
var StyledCircleText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "SwiperMain__StyledCircleText",
    componentId: "sc-65cfb678-6"
})(_templateObject11(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.black;
});
var SwiperMain = function(param, ref) {
    var carsStrip = param.carsStrip, resetSwiper = param.resetSwiper;
    var _$ref = (0,react.useState)(0), activeIndex = _$ref[0], setActiveIndex = _$ref[1];
    var _$ref1 = (0,react.useState)(0), colorIndex = _$ref1[0], setColorIndex = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), colorChange = _$ref2[0], setColorChange = _$ref2[1];
    var _$ref3 = (0,react.useState)(null), firstSwiper = _$ref3[0], setFirstSwiper = _$ref3[1];
    var _$ref4 = (0,react.useState)(null), secondSwiper = _$ref4[0], setSecondSwiper = _$ref4[1];
    var colorRef = (0,react.useRef)(null);
    var _$ref5 = (0,react.useState)(""), carLink = _$ref5[0], setCarLink = _$ref5[1];
    var nextColorIndex = carsStrip[0].modelColors[colorIndex + 1] ? colorIndex + 1 : 0;
    var handleColorChange = function() {
        setColorChange(true);
        colorRef.current = setTimeout(function() {
            setColorIndex(nextColorIndex);
            setColorChange(false);
        }, 960);
    };
    (0,react.useEffect)(function() {
        var card = carsStrip[activeIndex];
        var futureModel = (card === null || card === void 0 ? void 0 : card.carState) === "Future";
        var carLink = futureModel ? card.link : "/model/[modelId]/[modelSlug]".replace("[modelId]", card.id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(card.name));
        setCarLink(carLink);
    }, [
        activeIndex
    ]);
    (0,react.useEffect)(function() {
        // Clear the interval when the component unmounts
        return function() {
            // clearTimeout(timerRef.current)
            clearTimeout(colorRef.current);
        };
    }, []);
    // set useEffect to set swipers refs
    (0,react.useEffect)(function() {
        return function() {
            setFirstSwiper(null);
            setSecondSwiper(null);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (firstSwiper) {
            if (firstSwiper.realIndex !== 0) {
                firstSwiper.slideTo(1, 0);
                setActiveIndex(0);
            }
            setColorIndex(0);
        }
    }, [
        resetSwiper,
        firstSwiper
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrap, {
        id: "colorSwiper",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiperMain, {
                children: [
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTopText/* default */.Z, {
                        carData: carsStrip[activeIndex],
                        carLink: carLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorImageSwiper/* default */.Z, {
                        carsStrip: carsStrip,
                        setActiveIndex: setActiveIndex,
                        colorIndex: colorIndex,
                        setControlledSwiper: setFirstSwiper,
                        controlledSwiper: secondSwiper
                    }),
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperFooterText/* default */.Z, {
                        card: carsStrip[activeIndex],
                        activeIndex: colorIndex,
                        link: carLink,
                        colorIndex: colorIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDuplicateSwiperMain, {
                $start: colorChange,
                children: [
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTopText/* default */.Z, {
                        carData: carsStrip[activeIndex],
                        carLink: carLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorImageSwiper/* default */.Z, {
                        carsStrip: carsStrip,
                        setActiveIndex: setActiveIndex,
                        colorIndex: nextColorIndex,
                        setControlledSwiper: setSecondSwiper,
                        controlledSwiper: firstSwiper
                    }),
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperFooterText/* default */.Z, {
                        card: carsStrip[activeIndex],
                        activeIndex: colorIndex,
                        link: carLink,
                        colorIndex: colorIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnimationWrapper, {
                onClick: function() {
                    return (0,analytics/* trackPlayWithTheColorClicks */.dL)();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBaseBlank/* default */.Z, {
                        onClick: handleColorChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledColorCircle, {
                                disableButton: true,
                                height: 100,
                                hex: carsStrip[0].modelColors[nextColorIndex].colorHex,
                                imageUrl: carsStrip[0].modelColors[nextColorIndex].colorImage.imageUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCircleText, {
                                    variant: "body2",
                                    children: "שחקו עם הצבע"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCircleText, {
                            variant: "body2",
                            children: "שחקו עם הצבע"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledColorCircleAnimation, {
                        animationFlag: colorChange,
                        hex: carsStrip[0].modelColors[colorIndex + 1] ? carsStrip[0].modelColors[colorIndex + 1].colorHex : carsStrip[0].modelColors[0].colorHex
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var colorSwiper_SwiperMain = (/*#__PURE__*/(0,react.forwardRef)(SwiperMain));

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(50067);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./reusable/MoreDetailsButton.tsx + 2 modules
var MoreDetailsButton = __webpack_require__(90404);
;// CONCATENATED MODULE: ./components/homepage/mazdaTools/ToolsCard.tsx

function ToolsCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n  padding: 20px;\n  ",
        " {\n    width: 470px;\n  }\n"
    ]);
    ToolsCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ToolsCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: 320/100;\n  width: 100%;\n"
    ]);
    ToolsCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ToolsCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-weight: "normal";\n  margin-top: 10px;\n  margin-bottom: 4px;\n  ',
        " {\n    text-align: center;\n  }\n"
    ]);
    ToolsCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ToolsCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-weight: "300";\n  ',
        " {\n    text-align: center;\n  }\n"
    ]);
    ToolsCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ToolsCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  ",
        " {\n    width: 100%;\n    gap: 20px;\n    justify-content: center;\n  }\n"
    ]);
    ToolsCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ToolsCard__StyledWrapper",
    componentId: "sc-32d8cd09-0"
})(ToolsCard_templateObject(), function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var ToolsCard_StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ToolsCard__StyledImageContainer",
    componentId: "sc-32d8cd09-1"
})(ToolsCard_templateObject1());
var ToolsCard_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ToolsCard__StyledTitle",
    componentId: "sc-32d8cd09-2"
})(ToolsCard_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "h3"
}).withConfig({
    displayName: "ToolsCard__StyledText",
    componentId: "sc-32d8cd09-3"
})(ToolsCard_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFlexRow = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledRow */.N0).withConfig({
    displayName: "ToolsCard__StyledFlexRow",
    componentId: "sc-32d8cd09-4"
})(ToolsCard_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ToolsCard = function(param) {
    var toolsData = param.toolsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolsCard_StyledImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    image: toolsData.image,
                    role: "presentation",
                    ariaHidden: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledCol */.N6, {
                $notCenter: true,
                $fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolsCard_StyledTitle, {
                    children: toolsData.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                        children: toolsData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: toolsData.link,
                        onClick: function() {
                            return (0,analytics/* trackHpCubesClicks */["do"])();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreDetailsButton/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mazdaTools_ToolsCard = (ToolsCard);

;// CONCATENATED MODULE: ./components/homepage/mazdaTools/MazdaTools.tsx

function MazdaTools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 80px 20px;\n  overflow: hidden;\n  ",
        " {\n    padding: 100px 0px;\n    max-width: 100vw;\n    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n    transform: ",
        ";\n    opacity: ",
        ";\n    transition-delay: 0.3s;\n  }\n"
    ]);
    MazdaTools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MazdaTools_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 50px;\n"
    ]);
    MazdaTools_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MazdaTools_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow: visible;\n  .swiper-wrapper {\n    width: fit-content;\n    margin: 0px auto;\n  }\n  /* padding: 60px; */\n  /* max-width: calc(1920px - 100px - 100px); */\n"
    ]);
    MazdaTools_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MazdaTools_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: max-content;\n  box-sizing: border-box;\n  ",
        " {\n    height: auto;\n    &:nth-child(4) {\n      transform: ",
        ";\n      opacity: ",
        ";\n    }\n    &:nth-child(3) {\n      transform: ",
        ";\n      opacity: ",
        ";\n    }\n    &:nth-child(2) {\n      transform: ",
        ";\n      opacity: ",
        ";\n    }\n    &:nth-child(1) {\n      transform: ",
        ";\n      opacity: ",
        ";\n    }\n\n    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n    transition-delay: 0.3s;\n  }\n"
    ]);
    MazdaTools_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var MazdaTools_StyledWrapperContainer = (0,styled_components_browser_esm/* default */.ZP)(shared/* HomePageContainer */.Ts).withConfig({
    displayName: "MazdaTools__StyledWrapperContainer",
    componentId: "sc-2fac584f-0"
})(MazdaTools_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "translate3d(0, 0, 0)" : "translate3d(0, -85px, 0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledToolCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MazdaTools__StyledToolCol",
    componentId: "sc-2fac584f-1"
})(MazdaTools_templateObject1());
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "MazdaTools__StyledSwiper",
    componentId: "sc-2fac584f-2"
})(MazdaTools_templateObject2());
var StyledSwiperSlide = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* SwiperSlide */.o5).withConfig({
    displayName: "MazdaTools__StyledSwiperSlide",
    componentId: "sc-2fac584f-3"
})(MazdaTools_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-10%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-110%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-210%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateX(-310%)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var MazdaTools = function(param) {
    var toolsData = param.toolsData;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MazdaTools_StyledWrapperContainer, {
            $inView: inView,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledToolCol, {
                        children: toolsData.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(mazdaTools_ToolsCard, {
                                toolsData: item
                            }, item.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                        modules: [
                            swiper_esm/* A11y */.s5,
                            swiper_esm/* Keyboard */.N1
                        ],
                        initialSlide: 1,
                        allowTouchMove: true,
                        grabCursor: true,
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        slideToClickedSlide: true,
                        keyboard: {
                            enabled: true
                        },
                        children: toolsData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiperSlide, {
                                $inView: inView,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mazdaTools_ToolsCard, {
                                    toolsData: item
                                }, item.id)
                            }, "swiper-tools-".concat(index));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mazdaTools_MazdaTools = (MazdaTools);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
;// CONCATENATED MODULE: ./reusable/mintStory/FloatingText.tsx

function FloatingText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  color: white;\n  pointer-events: all;\n"
    ]);
    FloatingText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FloatingText_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    font-size: 32px;\n  }\n"
    ]);
    FloatingText_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FloatingText_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    font-weight: 300;\n    font-size: 40px;\n  }\n"
    ]);
    FloatingText_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FloatingText_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  color: white;\n  visibility: ",
        ";\n"
    ]);
    FloatingText_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FloatingText_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    FloatingText_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FloatingText_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  color: white;\n"
    ]);
    FloatingText_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FloatingText_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  inset-block-start: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgb(153, 153, 153);\n"
    ]);
    FloatingText_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FloatingText_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* position: relative; */\n  /* transform: translateY(calc(-200% - 2px)); */\n  visibility: ",
        ";\n  transform: translateY(40px);\n  pointer-events: none;\n  ",
        " {\n    transform: translateY(57px);\n  }\n"
    ]);
    FloatingText_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var StyledTextAnimation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs(function(param) {
    var $opacity = param.$opacity, $translateY = param.$translateY;
    return {
        style: {
            opacity: $opacity,
            transform: "translateY(".concat(100 - $translateY * 100 / 2, "px)"),
            visibility: $opacity === 0 ? "hidden" : "visible"
        }
    };
}).withConfig({
    displayName: "FloatingText__StyledTextAnimation",
    componentId: "sc-2d5317ab-0"
})(FloatingText_templateObject());
var StyledH2 = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).withConfig({
    displayName: "FloatingText__StyledH2",
    componentId: "sc-2d5317ab-1"
})(FloatingText_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledH1 = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).withConfig({
    displayName: "FloatingText__StyledH1",
    componentId: "sc-2d5317ab-2"
})(FloatingText_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).withConfig({
    displayName: "FloatingText__StyledSubtitle",
    componentId: "sc-2d5317ab-3"
})(FloatingText_templateObject3(), function(p) {
    return p.$hide ? "hidden" : "visible";
});
var StyledH1Heb = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).withConfig({
    displayName: "FloatingText__StyledH1Heb",
    componentId: "sc-2d5317ab-4"
})(FloatingText_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledBody = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).withConfig({
    displayName: "FloatingText__StyledBody",
    componentId: "sc-2d5317ab-5"
})(FloatingText_templateObject5());
var StyledProgressCircle = (0,styled_components_browser_esm/* default */.ZP)(StyledTextAnimation).attrs({
    component: "div"
}).withConfig({
    displayName: "FloatingText__StyledProgressCircle",
    componentId: "sc-2d5317ab-6"
})(FloatingText_templateObject6());
var StyledProgressCircleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingText__StyledProgressCircleWrapper",
    componentId: "sc-2d5317ab-7"
})(FloatingText_templateObject7(), function(p) {
    return p.$show ? "visible" : "hidden";
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var FloatingTextVariant;
(function(FloatingTextVariant) {
    FloatingTextVariant[FloatingTextVariant["HEADER1"] = 0] = "HEADER1";
    FloatingTextVariant[FloatingTextVariant["HEADER2"] = 1] = "HEADER2";
    FloatingTextVariant[FloatingTextVariant["SUBTITLE"] = 2] = "SUBTITLE";
    FloatingTextVariant[FloatingTextVariant["BODY"] = 3] = "BODY";
    FloatingTextVariant[FloatingTextVariant["REGULAR"] = 4] = "REGULAR";
    FloatingTextVariant[FloatingTextVariant["HEADER1HEB"] = 5] = "HEADER1HEB";
    FloatingTextVariant[FloatingTextVariant["ARROW_DOWN"] = 6] = "ARROW_DOWN";
})(FloatingTextVariant || (FloatingTextVariant = {}));
var TRANSITION_FRAME_DURATION = 15;
function FloatingText(param) {
    var count = param.count, middle = param.middle, start = param.start, end = param.end, variant = param.variant, text = param.text, _alwaysShow = param.alwaysShow, alwaysShow = _alwaysShow === void 0 ? false : _alwaysShow, progress = param.progress;
    var opacity = (0,react.useMemo)(function() {
        var startingToFadeOut = end - TRANSITION_FRAME_DURATION;
        var endOfFadeIn = middle ? middle : start + TRANSITION_FRAME_DURATION;
        // tamplate: // ((count - start) / (end - start)) * 1
        if (count === 0 && start === 0) {
            return 1;
        } else if (start !== 0 && count >= start && count <= endOfFadeIn) {
            // fade-in - linear opacity:
            return (count - start) / (endOfFadeIn - start) * 1;
        } else if (count >= start && count <= startingToFadeOut) {
            // regular opacity:
            return 1;
        } else if (count >= start && count <= end) {
            // fade-out opacity:
            return 1 - (count - startingToFadeOut) / (end - startingToFadeOut) * 1;
        } else {
            return 0;
        }
    }, [
        count,
        start,
        end,
        middle,
        alwaysShow
    ]);
    var translateY = (0,react.useMemo)(function() {
        var startingToFadeOut = end - TRANSITION_FRAME_DURATION;
        var endOfFadeIn = middle ? middle : start + TRANSITION_FRAME_DURATION;
        // tamplate: // ((count - start) / (end - start)) * 1
        if (count >= start && count <= endOfFadeIn) {
            // fade-in - linear opacity:
            return (count - start) / (endOfFadeIn - start) * 1;
        } else if (count >= start && count <= startingToFadeOut) {
            // regular Y:
            return 1;
        } else {
            return 1;
        }
    }, [
        count,
        start,
        end,
        middle
    ]);
    return variant === FloatingTextVariant.HEADER1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1, {
        variant: "h1",
        $opacity: opacity,
        $translateY: translateY,
        children: text
    }) : variant === FloatingTextVariant.SUBTITLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubtitle, {
        variant: "h3",
        component: "p",
        $opacity: opacity,
        $translateY: translateY,
        children: text
    }) : variant === FloatingTextVariant.BODY ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
        variant: "body1",
        $opacity: opacity,
        $translateY: translateY,
        children: text
    }) : variant === FloatingTextVariant.HEADER1HEB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1Heb, {
        variant: "h1",
        component: "p",
        $opacity: opacity,
        $translateY: translateY,
        children: text
    }) : variant === FloatingTextVariant.ARROW_DOWN ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressCircle, {
                $opacity: opacity,
                $translateY: translateY,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressCircleWrapper, {
                    $show: progress < 100,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        color: "inherit",
                        thickness: 1.5,
                        size: 50,
                        variant: "determinate",
                        value: progress
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubtitle, {
                variant: "h3",
                component: "div",
                $opacity: opacity,
                $translateY: translateY,
                $hide: progress < 100,
                children: text
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
        variant: "h2",
        component: "p",
        $opacity: opacity,
        $translateY: translateY,
        children: text
    });
}
/* harmony default export */ var mintStory_FloatingText = (FloatingText);

// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(39664);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(56546);
;// CONCATENATED MODULE: ./hooks/useWindowSize.tsx

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), windowSize = ref[0], setWindowSize = ref[1];
    var resizeTimeout = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        // Add event listener
        window.addEventListener("resize", function() {
            clearTimeout(resizeTimeout.current);
            resizeTimeout.current = setTimeout(handleResize, 200) // 200ms delay
            ;
            handleResize();
        });
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []) // Empty array ensures that effect is only run on mount
    ;
    return windowSize;
}

;// CONCATENATED MODULE: ./reusable/mintStory/FloatingTextContainer.tsx

function FloatingTextContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  /* why top + 60? */\n\n  top: ",
        ";\n  bottom: ",
        ";\n  left: 50%;\n  z-index: 99999;\n  transform: translateX(-50%);\n  height: fit-content;\n  width: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 15px;\n  pointer-events: none;\n  ",
        " {\n    height: fit-content;\n    width: ",
        "px;\n    top: ",
        ";\n    bottom: ",
        ";\n  }\n"
    ]);
    FloatingTextContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingTextContainer__StyledContainer",
    componentId: "sc-45fa81b3-0"
})(FloatingTextContainer_templateObject(), function(param) {
    var $top = param.$top;
    return $top ? "".concat($top[0], "px") : "auto";
}, function(param) {
    var $bottom = param.$bottom;
    return $bottom ? "".concat($bottom[0], "px") : "auto";
}, function(param) {
    var $width = param.$width;
    return $width[0];
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $width = param.$width;
    return $width[1];
}, function(param) {
    var $top = param.$top;
    return $top ? "".concat($top[1], "px") : "auto";
}, function(param) {
    var $bottom = param.$bottom;
    return $bottom ? "".concat($bottom[1], "px") : "auto";
});
function FloatingTextContainer(param) {
    var children = param.children, height = param.height, width = param.width, top = param.top, bottom = param.bottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        $height: height,
        $width: width,
        $top: top,
        $bottom: bottom,
        children: children
    });
}
/* harmony default export */ var mintStory_FloatingTextContainer = (FloatingTextContainer);

;// CONCATENATED MODULE: ./reusable/mintStory/helpers.tsx
function drawImageScaled(img, ctx, cover) {
    //scale dependant on ratio of canvas
    var canvas = ctx.canvas;
    var hRatio = canvas.width / img.width;
    var vRatio = canvas.height / img.height;
    var ratio = cover ? Math.max(hRatio, vRatio) : Math.min(hRatio, vRatio);
    var centerShift_x = (canvas.width - img.width * ratio) / 2;
    var centerShift_y = (canvas.height - img.height * ratio) / 2;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
}
function dropRender(dropContext, ref, dropImages, drop, setCount) {
    var _$ref, _$ref1;
    setCount(drop.dropFrame);
    dropContext.clearRect(0, 0, ref === null || ref === void 0 ? void 0 : (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.width, ref === null || ref === void 0 ? void 0 : (_$ref1 = ref.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.height);
    drawImageScaled(dropImages[drop.dropFrame], dropContext, true);
}
function wrapImageUrlWithNextImageParams(url, width) {
    return "_next/image?url=".concat(encodeURIComponent(url), "&w=").concat(width, "&q=80");
}

;// CONCATENATED MODULE: ./reusable/mintStory/MintStory.tsx

function MintStory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100vh;\n  transform: translate(0px, 0px);\n"
    ]);
    MintStory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MintStory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    MintStory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MintStory_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background: black;\n  transition: opacity 1.5s ease-in;\n  opacity: ",
        ";\n"
    ]);
    MintStory_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MintStory_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  background: ",
        ";\n  z-index: 1;\n  visibility: ",
        ";\n"
    ]);
    MintStory_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MintStory_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* :root {\n    height:100%;\n  }\n\n  body{\n    height:100%;\n  }\n\n  #__next {\n    height:100%;\n  } */\n  .pin-spacer{\n    // transition to next section positioning\n    margin-bottom:-85vh !important;\n    ",
        " {\n      margin-bottom:-89vh !important;\n  }\n    /* z-index: 1 !important; */\n    mix-blend-mode: darken;\n  }\n  ::-webkit-scrollbar-thumb {\n    background-color:  ",
        ";\n    border-radius:16px;\n  }\n"
    ]);
    MintStory_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var MintStory_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MintStory__StyledContainer",
    componentId: "sc-9b9d9e13-0"
})(MintStory_templateObject());
var StyledCanvas = styled_components_browser_esm/* default.canvas.withConfig */.ZP.canvas.withConfig({
    displayName: "MintStory__StyledCanvas",
    componentId: "sc-9b9d9e13-1"
})(MintStory_templateObject1());
var StyledFadeFromBlack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MintStory__StyledFadeFromBlack",
    componentId: "sc-9b9d9e13-2"
})(MintStory_templateObject2(), function(p) {
    return p.$show ? 1 : 0;
});
var StyledWhiteFade = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "white-fade"
}).withConfig({
    displayName: "MintStory__StyledWhiteFade",
    componentId: "sc-9b9d9e13-3"
})(MintStory_templateObject3(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.$show ? "visible" : "hidden";
});
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(MintStory_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.darkGrey;
});
//include gsap and scrolltrigger
gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger, ScrollToPlugin.ScrollToPlugin);
// ScrollTrigger.config({ ignoreMobileResize: true })
// ScrollTrigger.normalizeScroll(true)
function MintStory(param) {
    var textData = param.textData, mobilePath = param.mobilePath, desktopPath = param.desktopPath, framesCount = param.framesCount, headerSize = param.headerSize, extraPadding = param.extraPadding, onAlmostComplete = param.onAlmostComplete, speedUpFrom = param.speedUpFrom, scrollBtnRef = param.scrollBtnRef;
    var innerScrollBtnRef = scrollBtnRef.current;
    //State for canvas to be rendered
    var ref = (0,react.useState)(0), count = ref[0], setCount = ref[1];
    //State for image loading progress
    var ref1 = (0,react.useState)(0), progress = ref1[0], setProgress = ref1[1];
    // state for loading
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    //Canvas Ref
    var ref3 = (0,react.useRef)(null);
    //Container Ref
    var containerRef = (0,react.useRef)(null);
    var ref4 = useWindowSize(), width = ref4.width, height = ref4.height;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    // use effect that set the loading to false when the images are loaded
    (0,react.useEffect)(function() {
        if (progress === 100) {
            setLoading(false);
        }
    }, [
        progress
    ]);
    var currentDropFrame = (0,react.useCallback)(function(index) {
        return width < 768 ? wrapImageUrlWithNextImageParams("".concat(mobilePath).concat(index.toString().padStart(3, "0"), ".webp"), 856) : wrapImageUrlWithNextImageParams("".concat(desktopPath).concat(index.toString().padStart(3, "0"), ".webp"), 1920);
    }, [
        desktopPath,
        mobilePath,
        width
    ]);
    var initiateGsap = (0,react.useCallback)(function() {
        // if components loaded and got dom width & height for canvas to be responsive
        if (ref3.current && width && height) {
            var dropContext = ref3.current.getContext("2d");
            // Set the size of the canvas
            //  plus 2 to handle the scroll bar in smasung
            ref3.current.width = width + 2;
            // plus 10 to handle the screen size change
            ref3.current.height = height + 10;
            // Count the frames and set the path to the images
            var dropFrameCount = framesCount;
            // Set start frame
            var dropImages = [];
            var drop = {
                dropFrame: 0
            };
            var loadedImageCount = 0;
            // Go through frames from start to finish
            for(var i = 0; i < dropFrameCount; i++){
                var dropImg = new Image();
                // add style to canvas image
                // image to be cover
                dropImg.style.objectFit = "cover";
                dropImg.src = currentDropFrame(i);
                dropImages.push(dropImg);
                // if image is loaded add to loadedImageCount
                if (dropImg.complete) {
                    loadedImageCount++;
                    setProgress(loadedImageCount / dropFrameCount * 100);
                } else {
                    dropImg.addEventListener("load", function() {
                        loadedImageCount++;
                        // set progress to be used in loading bar
                        setProgress(loadedImageCount / dropFrameCount * 100);
                    });
                }
            }
            var scrollTimeout;
            // Function to add class
            var addScrollingClass = function() {
                innerScrollBtnRef.classList.add("hide-text");
            };
            // Function to remove class
            var removeScrollingClass = function() {
                innerScrollBtnRef.classList.remove("hide-text");
            };
            // Timeline of gsap
            var timeline = gsap/* gsap.timeline */.p8.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    //padding for menu
                    start: function() {
                        return width < 768 ? "top: ".concat(headerSize[0], "px") : "top: ".concat(headerSize[1], "px");
                    },
                    //length for the video/scroll extra padding on bottom
                    end: function() {
                        return "+=".concat(extraPadding);
                    },
                    toggleActions: "restart none none reverse",
                    //this makes frames to stick on scroll
                    scrub: 0,
                    //pin makes video pinned in container
                    pin: true,
                    //markers when animation starts
                    markers: false,
                    //auto padding no need for static height
                    pinSpacing: true,
                    invalidateOnRefresh: true,
                    fastScrollEnd: false,
                    onUpdate: function() {
                        clearTimeout(scrollTimeout);
                        addScrollingClass() // Remove class when scroll begins
                        ;
                        // Set a timeout to add the class if no scroll for 0.5 seconds
                        scrollTimeout = setTimeout(function() {
                            removeScrollingClass();
                        }, 500) // 0.5 seconds timeout until text is shown
                        ;
                    }
                }
            });
            // add animation to canvas
            // add zIndex to pin-spacer to make it on top
            timeline.add("pre").set(".pin-spacer", {
                zIndex: "1"
            }, "pre");
            // start animation
            timeline.add("start").to(drop, {
                dropFrame: dropFrameCount - 1,
                snap: "dropFrame",
                duration: function(progress) {
                    // Check if the current progress is after the speedup prop
                    var needsToSpeedUp = speedUpFrom ? progress > speedUpFrom : false;
                    // If it is within range, apply a shorter duration, else keep the existing duration (30)
                    return needsToSpeedUp ? 1 : 30;
                },
                // use animation onUpdate instead of scrollTrigger's onUpdate
                onUpdate: function() {
                    dropRender(dropContext, ref3, dropImages, drop, setCount);
                    if (drop.dropFrame > 412) {
                        innerScrollBtnRef.classList.add("invert");
                    } else {
                        innerScrollBtnRef.classList.remove("invert");
                    }
                }
            }, "start").to(innerScrollBtnRef, {
                left: isDesktop ? "20px" : "5px",
                transform: "translateX(0)",
                autoAlpha: 1,
                duration: 1,
                onStart: function() {
                    innerScrollBtnRef.classList.remove("show-text");
                },
                onComplete: function() {
                    innerScrollBtnRef.classList.add("show-text");
                },
                onReverseComplete: function() {
                    innerScrollBtnRef.classList.remove("show-text");
                }
            }, "0.1").to(innerScrollBtnRef, {
                duration: 1,
                toggleClass: "show-text"
            });
            // add scale and opacity to canvas when the animation ends
            timeline.add("end").to(ref3.current, {
                scale: 0.6,
                duration: 1
            }, "-=1");
            timeline.add("done").set(".pin-spacer", {
                autoAlpha: 0,
                duration: 0.3,
                onReverseComplete: onAlmostComplete
            }, "-=0.2");
            // remove zIndex from pin-spacer to make it below the next section
            timeline.add("done").set(".pin-spacer", {
                zIndex: "auto"
            }, "-=0");
            timeline.add("done").to(".white-fade", {
                autoAlpha: 0,
                duration: 0.2,
                onReverseComplete: onAlmostComplete
            }, "-=0.2").to(innerScrollBtnRef, {
                autoAlpha: 0,
                duration: 0.2
            });
            dropImages[0].onload = function() {
                return dropRender(dropContext, ref3, dropImages, drop, setCount);
            };
        }
    }, [
        currentDropFrame,
        extraPadding,
        framesCount,
        headerSize,
        height,
        width
    ]);
    (0,react.useEffect)(function() {
        if (width) {
            setTimeout(function() {
                initiateGsap();
            }, 0);
        }
        ScrollTrigger.ScrollTrigger.refresh();
        return function() {
            ScrollTrigger.ScrollTrigger.killAll();
        };
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        if (height && ref3.current) {
            setTimeout(function() {
                console.log(height);
                ref3.current.height = height;
            }, 0);
        }
    }, [
        height
    ]);
    //use effect that enable and disable scroll trigger by the loading state
    (0,react.useEffect)(function() {
        if (loading) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return function() {
            document.body.style.overflow = "";
        };
    }, [
        loading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhiteFade, {
                $show: !loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MintStory_StyledContainer, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCanvas, {
                        ref: ref3
                    }),
                    !count && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFadeFromBlack, {
                        $show: loading
                    }),
                    textData.map(function(param, containerIndex) {
                        var _containerProps = param.containerProps, height = _containerProps.height, width = _containerProps.width, top = _containerProps.top, bottom = _containerProps.bottom, children = param.children;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mintStory_FloatingTextContainer, {
                            height: height,
                            width: width,
                            top: top,
                            bottom: bottom,
                            children: children.map(function(param, childIndex) {
                                var text = param.text, variant = param.variant, start = param.start, end = param.end, middle = param.middle, alwaysShow = param.alwaysShow;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mintStory_FloatingText, {
                                    text: text,
                                    count: count,
                                    variant: variant,
                                    start: start,
                                    end: end,
                                    middle: middle,
                                    alwaysShow: alwaysShow,
                                    progress: progress
                                }, childIndex);
                            })
                        }, containerIndex);
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mintStory_MintStory = (MintStory);

;// CONCATENATED MODULE: ./reusable/icons/Janbo.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "167",
        height: "37",
        viewBox: "0 0 167 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.9533 7.51795C53.5109 7.91284 54.0628 8.43177 54.7055 10.2214C56.3816 9.66455 58.0627 9.10764 59.8143 8.52543V4.84736C58.5693 5.24225 57.3418 5.61436 56.127 6.01938C54.2544 6.64209 53.3899 6.31808 52.3162 4.54612C52.354 4.48031 52.3843 4.36893 52.4372 4.35374C56.4295 3.2855 60.4116 2.17677 64.4266 1.20219C65.3138 0.987024 66.3597 1.106 67.2519 1.35913C67.6754 1.48064 67.9072 2.28055 68.2273 2.77164C67.8266 2.98427 67.446 3.31082 67.0201 3.38929C65.1298 3.74115 63.2244 4.0196 61.2686 4.33349C61.692 4.95367 62.181 5.41944 62.3523 5.98394C62.5262 6.5535 62.3901 7.21925 62.3901 7.87234C63.3328 7.80399 64.162 7.67236 64.9836 7.70527C65.7044 7.73311 66.5513 7.93562 66.4202 8.87729C66.3774 9.18865 65.586 9.48229 65.092 9.61898C64.1746 9.87465 63.2269 10.0088 62.2389 10.2063V13.9679C63.0858 13.8615 63.9301 13.735 64.7744 13.654C65.2306 13.6084 65.7649 13.4869 66.1354 13.6666C66.6672 13.9223 67.0806 14.4235 67.5443 14.8209C67.1058 15.0361 66.6874 15.35 66.2261 15.4512C64.8399 15.755 63.4336 15.9778 61.9869 16.241C61.9062 17.5017 61.8331 18.661 61.755 19.8685C63.7209 19.6381 65.6162 19.3571 67.5216 19.2129C69.1548 19.0888 70.8057 19.0812 72.2549 20.076C73.7142 21.0785 74.1729 22.1189 73.7545 23.8301C72.7186 28.0701 71.0123 31.9659 67.7434 34.9959C67.1007 35.5908 66.3875 36.1376 65.6263 36.5679C64.2981 37.3172 63.4789 37.0691 62.3851 36.0009C61.4299 35.0668 60.3587 34.2542 59.3329 33.3936C58.8314 32.9734 58.3147 32.5709 57.9114 31.9709C59.0254 32.2342 60.1344 32.5202 61.2535 32.7582C63.1815 33.1683 65.1273 33.1455 66.9319 32.3582C67.7459 32.0038 68.6886 31.3027 68.986 30.5281C69.7774 28.465 70.4125 26.3108 70.8057 24.1364C71.2064 21.9214 70.2613 20.9722 68.0181 21.0253C62.6523 21.1493 57.5208 22.167 52.9387 25.1818C52.659 25.3666 52.3717 25.5565 52.0617 25.6704C51.2173 25.9843 50.5998 25.7514 50.5998 24.7692C50.5998 23.8503 50.5822 22.8783 50.8594 22.0227C52.3868 17.327 52.7825 12.5731 51.8474 7.71539C51.8424 7.68502 51.8827 7.64451 51.9533 7.51288V7.51795ZM54.5896 11.7048C54.4888 13.2262 54.3955 14.6564 54.2821 16.3625C56.3034 15.712 58.1257 15.1399 59.9328 14.5298C60.1168 14.4691 60.3461 14.1957 60.3537 14.0134C60.394 12.9958 60.3738 11.9782 60.3738 10.9859C58.2466 10.9328 56.7369 13.2439 54.5896 11.7023V11.7048ZM59.7564 20.3393C59.842 19.1977 59.9202 18.1269 60.0008 17.0561C58.0072 16.9979 56.2026 19.4306 54.1359 17.1776C53.8562 18.7977 53.6142 20.2153 53.3319 21.8607C55.6784 21.3063 57.7325 20.8203 59.7564 20.3393Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.256 1.7768C150.694 2.23245 150.465 2.41977 150.228 2.61215C150.157 2.49065 150.079 2.41724 150.082 2.35142C150.129 1.4376 149.784 0.237733 151.123 0.0301612C152.637 -0.205256 154.001 0.971829 153.902 2.36155C153.739 4.71319 153.472 7.05976 153.255 9.40634C153.23 9.68732 153.252 9.97336 153.252 10.4214C154.389 9.95311 155.407 9.53291 156.549 9.06461C155.999 8.25963 155.561 7.62426 155.125 6.98635L155.248 6.86232C156.539 7.80145 157.885 8.67478 159.102 9.70251C160.062 10.5151 159.818 11.2441 158.57 11.52C157.713 11.7099 156.829 11.7681 155.967 11.9276C155.105 12.0871 154.253 12.2997 153.726 12.4161C153.487 13.254 153.383 13.8919 153.121 14.4564C152.816 15.1146 152.904 15.4133 153.54 15.8664C155.1 16.9827 156.688 18.1244 157.998 19.509C159.674 21.281 161.411 22.8226 163.752 23.6554C164.664 23.9794 165.466 24.6502 166.265 25.2375C166.456 25.3793 166.547 25.8425 166.477 26.0982C166.431 26.2602 165.985 26.4171 165.738 26.3918C164.239 26.25 162.678 26.2627 161.272 25.8071C160.395 25.5235 159.684 24.5692 159.011 23.8149C157.481 22.0986 156.045 20.2988 154.517 18.5825C154.157 18.175 153.59 17.9548 152.978 17.5573V23.3238C153.89 23.3238 154.729 23.22 155.526 23.3643C155.997 23.4504 156.564 23.8377 156.791 24.2528C157.139 24.8907 157.124 25.5691 156.055 25.6273C155.102 25.6805 154.16 25.8501 153.187 25.9691C153.187 28.7181 153.257 31.3685 153.146 34.0087C153.111 34.8719 152.662 35.7477 152.264 36.5476C152.168 36.74 151.319 36.8438 151.163 36.6717C149.358 34.682 147.619 32.6316 145.868 30.5913C145.837 30.5559 145.898 30.442 145.915 30.3711C147.239 31.1381 148.542 31.9456 149.89 32.6595C151.057 33.2771 151.299 33.1151 151.314 31.8368C151.332 30.1205 151.319 28.4017 151.319 26.4045C149.343 27.3335 147.811 27.3537 146.803 25.4577C148.05 25.0097 149.27 24.6224 150.445 24.1212C150.767 23.9845 151.15 23.5238 151.16 23.1998C151.226 21.1898 151.193 19.1749 151.193 16.9144C147.98 21.1468 144.633 25.0021 139.672 27.4929C139.625 26.1994 139.884 25.1464 140.746 24.7869C142.73 23.9592 144.186 22.5087 145.505 20.9696C147.488 18.6534 149.252 16.1448 151.11 13.7173L150.835 13.3401C149.575 13.8059 148.292 14.221 147.062 14.7576C146.304 15.0893 145.699 15.1095 144.94 14.7045C144.267 14.345 143.438 14.2767 142.291 13.9805C143.534 13.3907 144.481 12.8136 145.507 12.4845C147.14 11.9605 148.831 11.6213 150.482 11.153C150.777 11.0694 151.226 10.7429 151.231 10.5201C151.281 7.71792 151.264 4.91317 151.264 1.76668L151.256 1.7768Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 29.4421L1.82068 26.3918L2.05003 26.6526C2.54402 26.4475 3.11867 26.3412 3.51941 26.0197C6.7102 23.4555 8.60804 19.909 10.6042 16.4486C11.4863 14.9197 12.2903 13.3426 13.117 11.7808C14.0445 10.0291 14.9367 8.27738 14.851 6.18648C14.8283 5.60173 15.1333 5.00433 15.3122 4.3158C15.8541 4.81701 16.2624 5.21696 16.6934 5.59414C18.3291 7.02942 18.3745 8.73809 17.0437 10.4822C15.5693 12.4162 14.2562 14.4716 12.8851 16.4815C12.7515 16.6765 12.6986 16.9245 12.565 17.2612C17.0185 16.9296 20.0732 19.4483 23.0599 22.0759C25.4189 24.1516 28.0552 25.7134 30.9411 26.9538C32.728 27.7208 34.3436 28.8928 36.0196 29.9104C36.2742 30.0648 36.4355 30.3737 36.6699 30.6471C32.2038 32.2114 28.4913 30.9483 24.8518 26.7665C22.15 23.663 19.1155 20.9747 15.2694 19.3546C15.1913 19.3217 15.1131 19.2888 15.035 19.2584C13.1565 18.5277 11.7484 19.0509 10.8108 20.8279C9.18773 23.8757 7.24956 26.6652 4.1495 28.3865C3.11111 28.9637 1.96938 29.3535 0.875536 29.832L0.50252 29.4396L0.5 29.4421Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M136.179 14.0084C137.671 14.7147 137.936 15.8538 137.941 17.1448C137.956 21.6506 138.027 26.1564 137.986 30.6597C137.979 31.5837 137.586 32.5051 137.291 33.7607C135.816 32.0925 135.325 30.4572 135.383 28.6751C135.421 27.5639 135.781 26.4627 135.821 25.3515C135.912 22.7847 135.927 20.2103 135.907 17.6409C135.902 16.9296 135.675 16.2208 135.504 15.2513C134.148 16.7119 133.024 17.9244 131.59 19.4686C131.164 18.1801 130.793 17.2764 130.599 16.3322C130.544 16.0614 130.927 15.5956 131.224 15.3728C135.02 12.5326 137.497 8.75077 139.032 4.31835C139.229 3.74879 139.06 3.0476 139.06 2.25275C140.242 2.17428 141.449 2.33376 142.505 3.05267C143.33 3.61463 143.395 4.52086 142.659 5.09548C139.688 7.41168 138.674 11.0847 136.179 14.0084Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M107.989 20.7595C109.643 19.8178 111.006 19.0407 112.695 18.0762C111.533 18.0028 110.668 17.8915 109.801 17.9016C103.886 17.9623 98.2101 18.9572 93.066 22.1366C91.4959 23.1061 89.4291 22.1214 89.1443 20.3368C89.0965 20.0381 89.3611 19.4407 89.5879 19.3824C91.8008 18.8027 94.0162 18.1497 96.272 17.8206C101.577 17.0435 106.908 16.441 112.223 15.7474C113.554 15.5727 114.87 15.3019 116.198 15.1095C117.985 14.8538 119.979 16.1929 120.47 17.9193C120.722 18.8002 120.379 19.2052 119.507 19.2432C119.464 19.2432 119.422 19.2483 119.381 19.2381C115.737 18.1724 112.48 19.7799 109.131 20.7317C108.97 20.7772 108.811 20.8329 108.647 20.8633C108.571 20.8785 108.488 20.8405 107.987 20.7595H107.989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.4298 29.2194C45.322 30.2192 46.3377 29.9079 47.3458 29.556C49.0042 28.9763 50.6299 28.2878 52.3211 27.8271C53.3065 27.5588 54.3878 27.6423 55.4262 27.5638C55.7967 27.536 56.1848 27.5613 56.5301 27.455C59.0908 26.6677 61.6364 25.8299 64.2021 25.0603C65.6614 24.6224 67.6827 26.1944 67.6449 27.7107C67.6399 27.9334 67.408 28.3106 67.2265 28.346C65.0968 28.7713 62.9596 29.1485 60.8223 29.5282C60.7643 29.5383 60.6912 29.4447 60.4946 29.313C61.8582 28.6776 63.1612 28.0727 64.4617 27.4677C64.4264 27.3284 64.3911 27.1892 64.3558 27.05C64.066 27.0247 63.761 26.9335 63.4863 26.9842C61.1953 27.4018 59.0253 28.1562 57.1173 29.5307C56.4318 30.0243 55.958 30.0345 55.2649 29.4472C53.9165 28.303 52.4572 29.0472 51.1541 29.6067C50.093 30.0623 49.1656 30.847 48.1952 31.5102C46.5267 32.6494 45.5135 32.3734 44.6516 30.5129C44.4852 30.1534 44.3365 29.7839 44.1777 29.4193L44.4298 29.2194Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Janbo = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/KodoLeft.tsx

var KodoLeft_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "39",
        height: "37",
        viewBox: "0 0 39 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23.3703 28.7642C23.3703 27.1151 23.4013 25.466 23.3496 23.8169C23.334 23.4136 23.0493 23.0154 22.8837 22.6171C22.4799 22.9337 21.9312 23.1685 21.7086 23.5821C21.2271 24.4705 20.9528 25.466 20.5283 26.3901C18.3489 31.1026 14.7149 34.2476 9.7867 35.9886C8.73584 36.3562 7.66427 36.683 6.58234 36.9229C6.25104 36.9995 5.84208 36.734 5.46936 36.6268C5.67125 36.2541 5.77996 35.7129 6.09573 35.5444C7.26566 34.9318 8.55465 34.5335 9.70387 33.8902C13.9539 31.5212 16.9409 28.1311 18.1833 23.3983C18.4421 22.418 18.6854 21.4326 18.9028 20.4422C18.9494 20.2328 18.8614 19.998 18.8303 19.7785C18.6336 19.952 18.3386 20.0848 18.2609 20.2992C17.7018 21.79 17.5672 21.9228 16.4025 21.8819C15.305 21.8462 14.9375 21.5348 14.9168 20.4166C14.8857 18.8084 14.9271 17.2052 14.9271 15.597C14.9271 14.4329 14.8547 14.341 13.721 14.3155C12.6494 14.29 11.5727 14.3308 10.4959 14.3002C9.66246 14.2798 9.15515 14.5759 8.82902 15.3775C7.74709 18.0477 6.5927 20.6872 5.47971 23.3421C5.1277 24.1794 5.25194 24.3683 6.14232 24.2407C7.24496 24.0824 8.35276 23.8833 9.42433 23.5974C10.6098 23.2809 10.7651 22.8724 10.2474 21.7237C10.0196 21.2233 9.67799 20.7638 9.50198 20.2533C9.39327 19.9469 9.36739 19.4262 9.55375 19.2577C9.74011 19.0841 10.382 19.0739 10.558 19.2475C12.1007 20.7638 13.84 22.1679 14.7097 24.1897C15.2688 25.4916 14.7667 26.7782 13.9022 27.8657C13.488 28.3864 12.7685 28.2333 12.4475 27.5695C12.1731 27.0028 11.9971 26.385 11.8004 25.7775C11.5985 25.1444 11.2206 25.0219 10.615 25.2771C8.44077 26.1859 6.23033 27.0232 4.08201 27.9882C3.42457 28.2843 2.87067 28.8663 2.36336 29.4024C1.7991 29.9998 1.35391 30.0662 1.01742 29.2952C0.582583 28.2945 0.29269 27.2224 0.0235033 26.1604C-0.116267 25.6039 0.297867 25.2363 0.825887 25.2312C2.53936 25.2108 3.0415 24.0722 3.37281 22.7141C3.94224 20.3707 4.55309 18.0426 5.10699 15.694C5.36065 14.6065 5.08111 14.2951 3.94742 14.3257C3.13468 14.3461 2.32194 14.4482 1.50921 14.4942C0.74306 14.5401 0.225393 14.2338 0.2461 13.422C0.26163 12.5643 0.91389 12.5898 1.54544 12.6102C3.77659 12.6664 6.01291 12.6919 8.24405 12.7736C9.36739 12.8145 10.1957 12.4775 10.8945 11.5585C11.7745 10.3995 11.935 10.4404 13.136 11.3798C13.4725 11.6402 13.7934 11.9261 14.1299 12.1814C14.7718 12.6664 15.0721 12.5796 15.0824 11.7882C15.1031 10.1851 15.0048 8.58195 14.9634 6.9737C14.9427 6.25892 14.9116 5.53904 14.9478 4.82426C14.9841 4.09417 15.4137 3.8491 16.0919 4.14012C16.563 4.33923 17.0082 4.60472 17.4637 4.83958C17.7277 4.97743 17.9814 5.15612 18.2557 5.25823C20.0986 5.92706 21.2841 5.4114 21.9519 3.60914C22.2728 2.73609 22.5213 1.83751 22.7801 0.944034C23.0131 0.147567 23.4893 -0.163873 24.3228 0.0760886C25.2701 0.351789 26.2433 0.540695 27.1648 0.872556C27.4547 0.974667 27.8119 1.42396 27.786 1.68945C27.7653 1.95494 27.3253 2.38891 27.0509 2.40933C25.6428 2.50123 25.0216 3.5785 24.2503 4.45155C23.6964 5.07443 23.7896 5.38077 24.5764 5.39608C26.4659 5.44203 28.3606 5.44714 30.2501 5.38077C30.6538 5.36545 31.1456 5.04891 31.42 4.72725C32.093 3.93589 32.7452 3.91547 33.5165 4.53324C33.7133 4.69152 33.9462 4.81405 34.1585 4.95701C35.67 5.97301 35.6649 6.15681 34.4587 7.51489C34.1792 7.82633 34.0032 8.34199 34.0032 8.76575C34.0135 11.5942 34.086 14.4278 34.1377 17.2563C34.1481 17.8077 34.1636 18.354 34.1843 18.9054C34.2154 19.7938 34.0239 20.5136 32.9471 20.6464C32.445 20.7077 32.2638 20.9629 32.5692 21.4326C32.9989 22.0811 32.6365 22.4282 32.0774 22.7346C31.7461 22.9133 31.332 23.1175 31.1974 23.4136C31.0628 23.7148 31.0939 24.2611 31.2958 24.496C32.1861 25.5222 33.1697 26.4667 34.1119 27.4521C34.6399 28.0086 34.8573 27.7738 35.054 27.1662C35.2197 26.6607 35.0695 25.7571 35.9496 25.9C36.7261 26.0277 36.5138 26.8394 36.5294 27.3959C36.5604 28.7489 36.5604 30.1019 36.5449 31.4549C36.5345 32.1748 36.7313 32.7108 37.3887 33.1703C38.3257 33.8238 38.2739 34.8807 37.2541 35.4168C36.5967 35.764 35.7943 35.9784 35.0488 35.9988C31.9998 36.0754 28.9455 36.0958 25.8965 36.0499C24.2244 36.0243 23.422 35.1207 23.4013 33.4614C23.3806 31.899 23.4013 30.3316 23.4013 28.7693H23.3858L23.3703 28.7642ZM28.3399 17.8588C28.6401 17.8588 28.9404 17.8588 29.2406 17.8588C30.7884 17.8332 30.8972 17.726 30.9127 16.1688C30.9127 16.0412 30.9127 15.9135 30.9127 15.7859C30.8609 13.3454 31.4614 13.1667 28.2001 13.1923C25.9327 13.2127 25.9327 13.2689 25.9327 15.4847C25.9327 17.0674 26.7334 17.8588 28.3347 17.8588H28.3399ZM29.9291 33.3031C30.7419 33.3031 31.5598 33.3439 32.3725 33.2878C33.3405 33.2214 34.3603 31.7969 34.117 30.8881C34.0808 30.7503 33.8013 30.5563 33.6822 30.5818C32.8591 30.7758 32.476 30.3163 32.2172 29.6832C31.9635 29.0604 31.5028 28.9531 30.98 29.2595C30.0482 29.8109 28.8368 29.9487 28.2674 31.0617C28.1639 31.266 27.7653 31.4344 27.5116 31.4242C26.9008 31.3987 26.497 31.5008 26.497 32.2054C26.497 32.9457 26.8956 33.2878 27.61 33.298C28.3813 33.3133 29.1526 33.298 29.9239 33.298L29.9291 33.3031ZM28.4124 11.5074C30.093 11.5177 30.9282 10.682 30.9179 9.00061C30.9179 8.74533 30.9023 8.49516 30.9075 8.23988C30.923 7.49447 30.5296 7.16771 29.7997 7.16771C29.1578 7.16771 28.5107 7.1524 27.8688 7.1575C25.9897 7.16771 25.9327 7.21877 25.9276 9.09251C25.9241 10.6957 26.7506 11.5006 28.4072 11.5074H28.4124ZM22.6507 15.5715C22.6507 15.3162 22.6507 15.066 22.6507 14.8107C22.6248 13.4118 22.5006 13.2842 21.1184 13.2484C19.1616 13.2008 18.1971 14.1249 18.2247 16.0208C18.2247 16.3169 18.147 16.6692 18.2816 16.8887C18.4939 17.241 18.8096 17.5984 19.172 17.7771C19.4878 17.9302 19.9278 17.8434 20.3109 17.8485C21.8708 17.8622 22.649 17.1014 22.6455 15.5664L22.6507 15.5715ZM22.6404 9.26099C22.6404 8.88318 22.6455 8.50026 22.6404 8.12245C22.63 7.58126 22.366 7.29025 21.8069 7.18303C18.82 6.601 17.8778 7.44852 18.2247 10.3893C18.3075 11.099 18.6233 11.4768 19.3584 11.4921C19.7 11.5023 20.0469 11.5074 20.3885 11.5074C21.8967 11.5074 22.649 10.7569 22.6455 9.25589L22.6404 9.26099ZM26.4866 23.7404H26.5177C26.5177 24.8789 26.5022 26.0174 26.5332 27.156C26.5332 27.3296 26.7248 27.4981 26.8283 27.6665C26.9784 27.544 27.1803 27.4521 27.2683 27.2938C27.4081 27.0386 27.4961 26.7475 27.5686 26.4616C27.9723 24.8227 28.3916 23.189 28.7592 21.5399C28.9197 20.8302 29.1681 20.3656 30.0378 20.4932C30.2967 20.529 30.5866 20.3196 30.8661 20.2277C30.5866 20.0235 30.3277 19.6712 30.0275 19.6355C29.2665 19.5487 28.49 19.61 27.7187 19.5895C26.8386 19.5691 26.4815 20.0031 26.4918 20.8302C26.5073 21.8002 26.4918 22.7703 26.4918 23.7404H26.4866ZM31.1249 26.5127L30.2811 25.4558C29.9343 26.0072 29.5719 26.5433 29.2717 27.1202C29.2406 27.1866 29.6133 27.6053 29.7635 27.5849C30.3122 27.5185 31.0162 27.5849 31.1249 26.5127ZM21.7034 19.5589L20.6836 19.8857C21.0874 20.0746 21.486 20.2839 21.9001 20.4524C22.0916 20.5341 22.3401 20.6158 22.5213 20.5647C22.7232 20.5034 23.0131 20.2992 23.0234 20.1409C23.0338 19.9725 22.806 19.7223 22.6145 19.6202C22.4488 19.5283 22.1952 19.5844 21.7086 19.564L21.7034 19.5589Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var KodoLeft = (KodoLeft_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/KodoRight.tsx

var KodoRight_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "37",
        height: "37",
        viewBox: "0 0 37 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.00991 17.9577C2.00991 16.1401 2.00991 14.3226 2.00991 12.505C2.00991 10.7129 2.43958 10.4117 3.91493 11.3971C5.19357 12.2497 6.54985 12.3416 7.97861 12.2548C8.96736 12.1935 9.22619 11.8566 9.23137 10.8865C9.23654 9.98795 8.74476 9.70714 7.92685 9.72756C5.73712 9.77862 3.54738 9.80925 1.35765 9.87562C0.451736 9.90115 0.0945462 9.61014 0.0841928 8.72687C0.0738395 7.89977 0.622566 7.9253 1.22824 7.94062C3.46456 7.98146 5.6957 7.98657 7.93202 8.0172C8.66711 8.02741 9.19513 7.84872 9.21584 6.98588C9.24172 6.03114 8.88971 5.67375 7.90096 5.77586C6.23407 5.94945 4.57236 6.14856 2.91065 6.32726C2.52758 6.3681 2.1238 6.46511 1.76143 6.39363C1.4353 6.33237 1.14541 6.07709 0.839986 5.9086C1.08847 5.66864 1.29554 5.29083 1.59061 5.20404C2.57935 4.91302 3.5888 4.7088 4.60343 4.50968C8.69817 3.68768 12.7153 2.64615 16.5564 0.976631C17.0015 0.78262 17.6642 0.797936 18.1249 0.976631C18.9583 1.29318 19.7452 1.76289 20.4854 2.26323C20.7805 2.46235 20.9048 2.91164 21.1118 3.24861C20.7546 3.43751 20.3819 3.82043 20.0454 3.7898C17.835 3.60599 15.8264 4.51478 13.7144 4.83133C12.9845 4.94365 12.4461 5.24999 12.3425 6.09751C12.1562 7.60875 12.4771 7.95083 14.0146 8.03762C15.5883 8.12952 17.0119 8.00188 18.0006 6.58254C18.3734 6.05156 18.86 6.13835 19.3362 6.51106C20.0402 7.06757 20.796 7.5628 21.4535 8.17037C21.7537 8.44607 21.878 8.91578 22.0799 9.29869C21.702 9.44165 21.3241 9.70203 20.941 9.70714C18.5338 9.74798 16.1267 9.71225 13.7195 9.74288C12.5651 9.7582 12.1044 10.2892 12.384 11.3409C12.4771 11.6932 12.943 12.1833 13.264 12.2038C14.7756 12.3059 16.3752 12.6479 17.5037 11.1265C18.0524 10.3862 18.6374 10.815 19.1343 11.2745C19.7245 11.8208 20.2421 12.3008 20.7805 11.1724C20.8996 10.9223 21.526 10.815 21.9194 10.8099C22.6027 10.7997 23.286 10.9682 23.9693 10.9733C25.2066 10.9835 25.6569 10.6159 25.6725 9.42123C25.7087 7.22584 25.6828 5.02534 25.6103 2.82995C25.5689 1.60972 25.688 1.36465 26.9097 1.39018C27.8053 1.4106 28.7163 1.49229 29.586 1.69141C30.6369 1.92627 30.8388 2.67678 29.9846 3.29456C29.1615 3.8868 29.0373 4.60668 29.0218 5.48995C28.9959 6.88377 28.8872 8.27248 28.8199 9.6663C28.7733 10.5547 29.1771 10.9784 30.1089 11.004C31.3823 11.0397 32.6092 11.0601 33.4685 9.88583C33.8827 9.32422 34.421 9.40591 34.9439 9.7633C35.2959 10.0033 35.6479 10.2483 35.9896 10.5036C37.2061 11.4175 37.232 11.7085 36.4399 13.0155C36.207 13.3985 36.0413 13.8631 36.0051 14.3021C35.6427 18.7236 35.3787 23.1501 34.9439 27.5613C34.7679 29.3584 34.3123 31.1403 33.8464 32.8915C33.189 35.3932 31.0148 36.2305 28.9182 36.5318C28.5869 36.5777 27.9916 36.3122 27.8726 36.0467C27.2772 34.6733 26.0607 34.3415 24.7821 34.0556C24.3628 33.9586 23.9279 33.9228 23.5242 33.7799C23.3274 33.7084 23.0738 33.4531 23.0738 33.2846C23.0738 33.0906 23.3016 32.8098 23.4983 32.7332C23.8037 32.6158 24.1712 32.5903 24.5077 32.6056C25.8381 32.6617 27.1633 32.769 28.4937 32.82C30.0985 32.8864 30.6628 32.5596 30.9268 31.0178C31.4134 28.1893 31.8638 25.3455 32.1226 22.4915C32.3866 19.6324 32.4021 16.7528 32.5212 13.8835C32.5678 12.842 32.3659 12.6224 31.3047 12.5458C31.2633 12.5458 31.2167 12.5458 31.1753 12.5458C28.7526 12.4284 28.7112 12.5458 28.5041 14.9046C28.1314 19.0809 27.5464 23.2369 25.7035 27.0814C23.4361 31.8091 19.7762 35.0971 14.8273 36.981C14.5116 37.0985 14.0767 36.9096 13.6988 36.8636C13.8541 36.5011 13.9059 36.011 14.1803 35.8017C15.3398 34.9286 16.5978 34.1832 17.7418 33.2999C18.2388 32.917 18.5649 32.3095 18.9687 31.804C18.3578 31.8346 17.7315 31.7785 17.1413 31.9061C12.8602 32.8251 8.58946 33.7952 4.30836 34.7244C3.53186 34.8929 2.87442 35.0767 2.41887 35.8425C1.99956 36.5522 1.24894 36.5011 0.933166 35.7455C0.544916 34.8163 0.270551 33.8258 0.0945444 32.8353C-0.0452256 32.0338 0.638098 31.8908 1.27483 31.85C2.85889 31.7478 4.44812 31.6713 6.03218 31.564C6.67409 31.5232 7.316 31.4568 7.95273 31.3547C9.03983 31.176 9.23137 30.8544 9.21584 29.7005C9.20031 28.71 8.63087 28.5007 7.78707 28.5211C5.81476 28.5773 3.83728 28.5773 1.86497 28.6794C1.07811 28.7202 0.586329 28.5416 0.524209 27.7298C0.456912 26.8771 1.05741 26.7801 1.70967 26.7852C3.72857 26.7955 5.75264 26.8261 7.77154 26.8159C9.0243 26.8108 9.21066 26.5861 9.20549 25.2893C9.20549 23.9976 8.99842 23.7474 7.76637 23.727C6.7621 23.7117 5.81477 23.5892 4.99168 24.595C4.59825 25.0698 3.42314 25.0442 2.62076 25.0034C2.38263 24.9932 2.02027 24.1508 2.00474 23.6811C1.93226 21.7818 1.97368 19.8774 1.97368 17.973H1.98403L2.00991 17.9577ZM16.8566 28.5007V28.5211C15.7384 28.5211 14.6255 28.516 13.5073 28.5211C12.8084 28.5262 12.3425 28.7866 12.415 29.5831C12.4771 30.2877 12.7049 30.834 13.5642 30.788C13.9939 30.7625 14.4184 30.7267 14.8429 30.6757C16.458 30.4868 18.0731 30.1702 19.6934 30.1498C20.5217 30.1396 20.9513 29.9098 21.3448 29.2768C22.7062 27.0967 23.7726 24.7992 24.2282 22.277C24.6682 19.8315 25.0047 17.3604 25.367 14.8995C25.6828 12.7654 25.3774 12.5254 23.1721 12.5152C21.0808 12.5101 19.652 14.1081 19.7607 15.9359C19.9005 18.2487 19.7969 20.5769 19.7969 22.8999C19.7969 23.5841 19.8021 24.2937 19.0101 24.6154C18.2284 24.9319 18.4251 25.3199 18.9014 25.7233C19.4242 26.1573 20.0092 26.53 20.501 26.9997C20.7443 27.2345 21.0445 27.7553 20.941 27.9238C20.7702 28.2097 20.3043 28.4497 19.9471 28.4752C18.9221 28.5467 17.8868 28.5007 16.8566 28.5007ZM14.4029 22.1647C16.5978 22.1647 16.9032 21.8277 16.7013 19.7651C16.6288 18.9942 16.2561 18.5398 15.49 18.6368C14.4391 18.7695 13.0207 17.9628 12.4461 19.4332C11.7524 21.21 12.5134 22.1647 14.408 22.1647H14.4029ZM14.4443 17.1051C16.4425 17.1051 16.634 16.9877 16.6961 15.7062C16.7738 14.0469 16.5512 13.812 14.8481 13.7967C14.5064 13.7967 14.1647 13.8171 13.8231 13.7967C12.9327 13.7456 12.5134 14.149 12.3891 15.022C12.1614 16.6864 12.5393 17.1 14.4443 17.1051ZM7.41953 18.4325C5.48863 18.6061 5.29192 18.8001 5.33851 20.6381C5.36957 21.9299 5.55076 22.1188 6.81386 22.1596C7.32635 22.1749 7.8492 22.1902 8.35133 22.1188C8.61534 22.083 9.04501 21.8686 9.06054 21.7052C9.13301 20.8373 9.26243 19.9132 9.0243 19.1116C8.92076 18.7593 7.97861 18.6521 7.41953 18.4325ZM14.8998 23.7015C14.5478 23.7015 14.377 23.7015 14.201 23.7015C12.7515 23.7372 11.9284 24.983 12.5134 26.2849C12.6014 26.484 12.8499 26.6729 13.0673 26.7444C14.3873 27.1937 16.049 26.6882 16.9135 25.662C17.2345 25.274 17.2656 24.983 16.986 24.5388C16.4321 23.6555 15.5883 23.676 14.8998 23.6964V23.7015ZM7.37812 17.1051C9.11748 17.1051 9.30384 16.9111 9.23654 15.2263C9.23654 15.0986 9.22101 14.9761 9.22101 14.8484C9.20031 14.1847 8.84829 13.8477 8.1805 13.8222C7.83884 13.8069 7.49718 13.7967 7.15552 13.8018C5.50417 13.812 5.28157 14.0367 5.33333 15.6194C5.37475 16.9468 5.60252 17.1102 7.3833 17.1051H7.37812Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var KodoRight = (KodoRight_SvgComponent);

;// CONCATENATED MODULE: ./components/homepage/story/Story.tsx

function Story_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 11px;\n  // mobile\n  ",
        " {\n    width: 40px;\n    gap: 3.5px;\n    margin-bottom: -10px;\n  }\n"
    ]);
    Story_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Story_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 70px;\n    margin-bottom: -20px;\n    svg {\n      width: 100%;\n    }\n  }\n"
    ]);
    Story_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Story_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%,\n	100% {\n		transform: translateY(0);\n	}\n\n	8%,\n	24%,\n	40%,\n	56% {\n		transform: translateY(-2.5px);\n	}\n\n	16%,\n	32%,\n	48% {\n		transform: translateY(2.5px);\n	}\n\n	64% {\n		transform: translateY(2px);\n	}\n\n	72% {\n		transform: translateY(-2px);\n	}\n\n  80%{\n    transform: translateY(0);\n  }\n"
    ]);
    Story_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Story_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* transform: translateY(-100%); */\n  // add loop down animation to svg path with id arrow\n  svg path#arrow {\n    animation: ",
        " 5s ease 0s infinite normal forwards;\n    transition: stroke 0.3s ease-in-out;\n  }\n  svg rect {\n    transition: all 0.3s ease-in-out;\n  }\n  &:hover,\n  &:focus {\n    svg path#arrow {\n      stroke: ",
        ";\n    }\n    svg rect {\n      fill: ",
        ";\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    Story_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var API_URL = "https://api.mazda.co.il";
var StyledJapCont = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Story__StyledJapCont",
    componentId: "sc-84aac42a-0"
})(Story_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledJanboWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Story__StyledJanboWrap",
    componentId: "sc-84aac42a-1"
})(Story_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var arrowDown = (0,styled_components_browser_esm/* keyframes */.F4)(Story_templateObject2());
var StyledArrowDownWrap = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "Story__StyledArrowDownWrap",
    componentId: "sc-84aac42a-2"
})(Story_templateObject3(), arrowDown, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.black;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
});
function Story(param) {
    var brandStory = param.brandStory, resetSwiper = param.resetSwiper, scrollBtnRef = param.scrollBtnRef, hasCampaign = param.hasCampaign;
    (0,react.useEffect)(function() {}, [
        scrollBtnRef
    ]);
    var textData = [
        /////////////// 1. Opening
        {
            containerProps: {
                height: [
                    280,
                    280
                ],
                width: [
                    318,
                    501
                ],
                top: hasCampaign ? undefined : [
                    20,
                    10
                ],
                bottom: hasCampaign ? [
                    175,
                    250
                ] : undefined
            },
            children: [
                {
                    text: brandStory.openingTitle,
                    variant: FloatingTextVariant.HEADER1,
                    start: 0,
                    end: 10
                },
                {
                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledArrowDownWrap, {
                        onClick: function() {
                            console.log("scroll");
                            (0,analytics/* trackSkipStoryOne */.p7)();
                            gsap/* gsap.to */.p8.to(window, {
                                duration: 0.7,
                                scrollTo: {
                                    y: 500
                                },
                                ease: "power2.inOut"
                            });
                        },
                        "aria-label": "מעבר להמשך הסיפור",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "srOnly",
                                component: "p",
                                children: "גלול להמשך הסיפור"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoWhite/* default */.Z, {})
                        ]
                    }),
                    variant: FloatingTextVariant.ARROW_DOWN,
                    start: 0,
                    end: 10
                }, 
            ]
        },
        {
            containerProps: {
                height: [
                    280,
                    280
                ],
                width: [
                    318,
                    501
                ],
                top: [
                    20,
                    10
                ]
            },
            children: [
                {
                    text: brandStory.openingTitle,
                    variant: FloatingTextVariant.HEADER1,
                    start: 0,
                    middle: 14,
                    end: 60
                },
                {
                    text: brandStory.openingDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 14,
                    end: 60
                },
                {
                    text: "PREPARE TO BE AMAZED",
                    variant: FloatingTextVariant.SUBTITLE,
                    start: 14,
                    end: 60
                }, 
            ]
        },
        /////////////// 2. Clay Description
        // הסיפור מתחיל בחימר
        {
            containerProps: {
                height: [
                    280,
                    280
                ],
                width: [
                    318,
                    501
                ],
                top: [
                    35,
                    25
                ]
            },
            children: [
                {
                    text: brandStory.clayTitle,
                    variant: FloatingTextVariant.HEADER1HEB,
                    start: 60,
                    middle: 70,
                    end: 105
                },
                {
                    text: brandStory.clayDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 70,
                    end: 105
                }, 
            ]
        },
        /////////////// 3.Movement
        // problem here!
        // נשמה בתנועה
        {
            containerProps: {
                height: [
                    271,
                    273
                ],
                width: [
                    320,
                    488
                ],
                top: [
                    20,
                    10
                ]
            },
            children: [
                {
                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJapCont, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KodoLeft, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KodoRight, {})
                        ]
                    }),
                    variant: FloatingTextVariant.SUBTITLE,
                    start: 106,
                    middle: 125,
                    end: 152
                },
                {
                    text: "KODO",
                    variant: FloatingTextVariant.SUBTITLE,
                    start: 106,
                    middle: 125,
                    end: 152
                },
                {
                    text: brandStory.movementTitle,
                    variant: FloatingTextVariant.HEADER1HEB,
                    start: 125,
                    middle: 135,
                    end: 152
                },
                {
                    text: brandStory.movementDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 125,
                    middle: 135,
                    end: 152
                }, 
            ]
        },
        //////////////// 4.Inside beauty
        // יופי פנימי
        {
            containerProps: {
                height: [
                    205,
                    176
                ],
                width: [
                    320,
                    488
                ],
                top: [
                    0,
                    10
                ]
            },
            children: [
                {
                    text: brandStory.insideBeautyTitle,
                    variant: FloatingTextVariant.HEADER1HEB,
                    start: 162,
                    middle: 178,
                    end: 224
                },
                {
                    text: brandStory.insideBeautyDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 178,
                    end: 224
                }, 
            ]
        },
        /////////////// 5. Safety
        // הביטחון להינות
        {
            containerProps: {
                height: [
                    180,
                    176
                ],
                width: [
                    320,
                    492
                ],
                top: [
                    35,
                    25
                ]
            },
            children: [
                {
                    text: brandStory.safetyTitle,
                    variant: FloatingTextVariant.HEADER2,
                    start: 280,
                    middle: 295,
                    end: 323
                },
                {
                    text: brandStory.safetyDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 289,
                    end: 323
                }, 
            ]
        },
        /////////////// 6.Driving Experience
        // חווית נהיגה
        {
            containerProps: {
                height: [
                    240,
                    298
                ],
                width: [
                    320,
                    459
                ],
                top: [
                    20,
                    10
                ]
            },
            children: [
                {
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJanboWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Janbo, {})
                    }),
                    variant: FloatingTextVariant.SUBTITLE,
                    start: 323,
                    middle: 342,
                    end: 380
                },
                {
                    text: "JINBA ITTAI",
                    variant: FloatingTextVariant.HEADER2,
                    start: 323,
                    middle: 342,
                    end: 380
                },
                {
                    text: brandStory.drivingExperienceTitle,
                    variant: FloatingTextVariant.HEADER1HEB,
                    start: 328,
                    middle: 342,
                    end: 380
                },
                {
                    text: brandStory.drivingExperienceDescription,
                    variant: FloatingTextVariant.BODY,
                    start: 332,
                    end: 380
                }, 
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mintStory_MintStory, {
        textData: textData,
        mobilePath: "".concat(API_URL, "/Uploads/story/mobile/Mazda_Laatar_306983_856x1460_fix"),
        desktopPath: "".concat(API_URL, "/Uploads/story/desktop/Mazda_Laatar_306983_1920x940_fix"),
        headerSize: [
            shared/* HEADER_ANIME_M */.yv,
            shared/* HEADER_ANIME_D */.oe
        ],
        // headerSize={[HEADER_HEIGHT_M, HEADER_HEIGHT_D]}
        framesCount: 422,
        extraPadding: 14000,
        onAlmostComplete: resetSwiper,
        speedUpFrom: 412,
        scrollBtnRef: scrollBtnRef
    });
}
/* harmony default export */ var story_Story = (Story);

// EXTERNAL MODULE: ./common/isValidMediaUrl.ts
var isValidMediaUrl = __webpack_require__(13354);
;// CONCATENATED MODULE: ./components/homepage/TopBanner/TopBanner.tsx

function TopBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-color: ",
        ";\n  z-index: 2;\n  width: 100%;\n"
    ]);
    TopBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  z-index: 2;\n  position: relative;\n  padding-top: 36px;\n  ",
        " {\n    padding-top: 16px;\n  }\n"
    ]);
    TopBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(\n      0deg,\n      rgba(3, 47, 76, 0.2) 0%,\n      rgba(3, 47, 76, 0.2) 100%\n    ),\n    rgba(255, 255, 255, 0.12);\n  ",
        "\n  margin-top: 36px;\n  height: 280px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n  padding: 8px 16px 16px 16px;\n\n  gap: 16px;\n  z-index: 2;\n  ",
        " {\n    height: 260px;\n\n    padding: 16px 16px 32px 16px;\n  }\n"
    ]);
    TopBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopBanner_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  ",
        " {\n    width: 55%;\n  }\n  ",
        " {\n    inset-block-start: 20px;\n  }\n"
    ]);
    TopBanner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopBanner_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    TopBanner_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TopBanner_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-bottom: auto;\n  line-height: 1.2;\n  p {\n    margin: 0;\n  }\n"
    ]);
    TopBanner_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TopBanner_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    TopBanner_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var TopBanner_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopBanner__StyledWrapper",
    componentId: "sc-f6722696-0"
})(TopBanner_templateObject(), function(p) {
    return p.theme.colors.headerColor;
});
var TopBanner_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(shared/* HomePageContainer */.Ts).withConfig({
    displayName: "TopBanner__StyledContainer",
    componentId: "sc-f6722696-1"
})(TopBanner_templateObject1(), function(p) {
    return p.theme.colors.headerColor;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledTopBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopBanner__StyledTopBanner",
    componentId: "sc-f6722696-2"
})(TopBanner_templateObject2(), function(p) {
    return p.$bgColor && "background-color: ".concat(p.$bgColor, ";");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopBanner__StyledImageWrapper",
    componentId: "sc-f6722696-3"
})(TopBanner_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopBanner__StyledContent",
    componentId: "sc-f6722696-4"
})(TopBanner_templateObject4());
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "TopBanner__StyledTypography",
    componentId: "sc-f6722696-5"
})(TopBanner_templateObject5());
// const StyledTypographySubtitle = styled(Typography)`
//   position: relative;
// `
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "TopBanner__StyledButton",
    componentId: "sc-f6722696-6"
})(TopBanner_templateObject6());
var BannerImage = function(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
        image: image,
        priority: true,
        cover: false,
        objectPosition: "bottom right"
    });
};
var TopBanner = function(param) {
    var data = param.data;
    if (!data) return null;
    var imageMob = data.imageMob, imageWeb = data.imageWeb, buttonText = data.buttonText, buttonUrl = data.buttonUrl, isActive = data.isActive, titleWeb = data.titleWeb, titleMob = data.titleMob, color = data.color, isButtonActive = data.isButtonActive;
    if (!isActive) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBanner_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBanner_StyledContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopBanner, {
                $bgColor: color,
                children: [
                    (0,isValidMediaUrl/* isValidMediaUrl */.d)(imageMob === null || imageMob === void 0 ? void 0 : imageMob.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                        aboveTheFold: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                                image: imageMob
                            })
                        })
                    }),
                    (0,isValidMediaUrl/* isValidMediaUrl */.d)(imageWeb === null || imageWeb === void 0 ? void 0 : imageWeb.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        aboveTheFold: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                                image: imageWeb
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: titleMob && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                    variant: "h2",
                                    color: "secondary",
                                    align: "center",
                                    component: "div",
                                    dangerouslySetInnerHTML: {
                                        __html: titleMob
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                children: titleWeb && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                    variant: "h2",
                                    color: "secondary",
                                    align: "center",
                                    component: "div",
                                    dangerouslySetInnerHTML: {
                                        __html: titleWeb
                                    }
                                })
                            }),
                            isButtonActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: buttonUrl,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    children: buttonText
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TopBanner_TopBanner = (TopBanner);

;// CONCATENATED MODULE: ./components/homepage/HomePage.tsx

function HomePage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  display: inline-flex;\n  z-index: 100;\n  border-radius: 48px;\n  border: none;\n  transform: translateX(-100px);\n  visibility: hidden;\n  opacity: 0;\n  left: 20px;\n  bottom: 20px;\n\n  div {\n    overflow: hidden;\n  }\n\n  p {\n    color: ",
        ";\n    font-size: 20px;\n    font-weight: 300;\n    line-height: 160%;\n    letter-spacing: 0.6px;\n    flex: 0 0 auto;\n    transform: translateX(-100px);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.6s ease-in-out;\n    padding-inline-end: 8px;\n    ",
        " {\n      padding-inline-end: 16px;\n      transition-duration: 0.5s;\n    }\n  }\n\n  &.show-text {\n    p {\n      transform: translateX(0);\n      opacity: 1;\n      visibility: visible;\n    }\n    &.hide-text {\n      p {\n        transform: translateX(-100px);\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  }\n\n  &:hover,\n  &:focus {\n    background-color: transparent !important;\n    border: none;\n\n    svg path#arrow {\n      stroke: ",
        ";\n    }\n    svg rect {\n      fill: ",
        ";\n      stroke: ",
        ";\n    }\n  }\n  /* @media (hover: none) {\n    &:hover {\n      p {\n        transform: translateX(-100px);\n        opacity: 0;\n        visibility: hidden;\n      }\n    } */\n\n  svg path#arrow {\n    flex: 0 0 auto;\n    stroke: ",
        ";\n    border-color: ",
        ";\n    animation: ",
        " 5s ease 0s infinite normal forwards;\n  }\n\n  &.invert {\n    svg path#arrow {\n      stroke: ",
        ";\n      border-color: ",
        ";\n    }\n    p {\n      color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    left: 5px;\n    bottom: 45px;\n    svg {\n      width: 35px;\n      height: 35px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    HomePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var HomePage_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "HomePage__StyledButton",
    componentId: "sc-47660202-0"
})(HomePage_templateObject(), function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.black;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.white;
}, arrowDown, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.black;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.black;
}, function(p) {
    return p === null || p === void 0 ? void 0 : p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var HomePage = function(param) {
    var homepageData = param.homepageData;
    var ref = (0,react.useState)(false), stroyEventTriggered = ref[0], setStoryEventTriggered = ref[1];
    var secondElementRef = (0,react.useRef)(null);
    var scrollBtnRef = (0,react.useRef)(null);
    var handleSkipToEnd = function() {
        (0,analytics/* trackSkipStoryTwo */.rK)();
        gsap/* gsap.to */.p8.to(window, {
            duration: 10,
            scrollTo: {
                y: secondElementRef.current,
                offsetY: 80
            },
            ease: "power2.inOut"
        });
    };
    (0,react.useEffect)(function() {}, [
        scrollBtnRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBanner_TopBanner, {
                    data: homepageData.topBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
                brandStory: homepageData.brandStory,
                resetSwiper: function() {
                    setStoryEventTriggered(function(prev) {
                        return !prev;
                    });
                },
                scrollBtnRef: scrollBtnRef,
                hasCampaign: !!homepageData.topBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePage_StyledButton, {
                $campaign: !homepageData.topBanner,
                id: "skipStory",
                variant: "outlined",
                color: "secondary",
                onClick: handleSkipToEnd,
                ref: scrollBtnRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "srOnly",
                                    children: "בלחיצה "
                                }),
                                "דלגו לדגמים"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoWhite/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(colorSwiper_SwiperMain, {
                ref: secondElementRef,
                carsStrip: homepageData.homePageCarsStrip,
                resetSwiper: stroyEventTriggered
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mazdaTools_MazdaTools, {
                toolsData: homepageData.promotions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_Blog, {
                blogData: homepageData.blogs
            })
        ]
    });
};
/* harmony default export */ var homepage_HomePage = (HomePage);

;// CONCATENATED MODULE: ./src/pages/index.tsx

function pages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  overflow: hidden;\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "pages__StyledPageWrapper",
    componentId: "sc-6dbd1d4d-0"
})(pages_templateObject(), shared/* HEADER_ANIME_M */.yv, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_ANIME_D */.oe);
var Home = function(param) {
    var homepageData = param.homepageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_HomePage, {
                    homepageData: homepageData
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8802,4856,6043,1676,9867,6205,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);